import { FC, default as React } from 'react';

import { SHeader } from './style';

const Header: FC = ({ children }) => <SHeader>{children}</SHeader>;

export default Header;
